import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnSecondaryBtnComponent } from './dn-secondary-btn.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [DnSecondaryBtnComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [DnSecondaryBtnComponent],
})
export class DnSecondaryBtnModule {}
